import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQ_GROUPS = [
  {
    title: "General",
    overline: "Overview",
    items: [
      {
        q: "What manufacturing services does White Bull Global offer?",
        a: "We provide end-to-end solutions including product development, contract manufacturing, private labelling, packaging, and regulatory support for nutraceutical and Ayurvedic products.",
      },
      {
        q: "Where is your manufacturing facility located?",
        a: "Our state-of-the-art facility is located at Barhi Industrial Area, Sonipat (Haryana), designed to meet modern nutraceutical manufacturing standards.",
      },
      {
        q: "What dosage forms do you manufacture?",
        a: "We manufacture tablets, capsules, powders, effervescent tablets, liquids, and herbal formulations.",
      },
    ],
  },
  {
    title: "Product Development & R&D",
    overline: "Formulation",
    items: [
      {
        q: "Do you assist in formulation development?",
        a: "Yes, our R&D team supports formulation development based on your product concept, target audience, and regulatory requirements.",
      },
      {
        q: "Can you customise formulations as per our requirements?",
        a: "Absolutely. We specialise in customised formulations, including blends with ingredients like Ashwagandha, Shilajit, vitamins, and herbal extracts.",
      },
      {
        q: "Do you provide support for innovative products?",
        a: "Yes, we actively work on innovative formats such as effervescent tablets, functional beverages, and condition-specific nutraceutical blends.",
      },
    ],
  },
  {
    title: "Compliance & Certifications",
    overline: "Regulatory",
    items: [
      {
        q: "Are your products compliant with regulatory standards?",
        a: "Yes, our manufacturing processes adhere to FSSAI and AYUSH guidelines, along with GMP standards.",
      },
      {
        q: "Do you provide documentation for regulatory approvals?",
        a: "We assist with required documentation including COA (Certificate of Analysis), product specifications, and label compliance.",
      },
      {
        q: "Can you support export-compliant manufacturing?",
        a: "Yes, we can align formulations and documentation as per export market requirements.",
      },
    ],
  },
  {
    title: "Private Labelling & Branding",
    overline: "Your brand, our line",
    items: [
      {
        q: "Do you offer private labelling services?",
        a: "Yes, we provide complete private labelling solutions including packaging, branding, and label design support.",
      },
      {
        q: "Can you help with packaging design and creatives?",
        a: "We can assist with packaging concepts and ensure compliance with regulatory labelling norms.",
      },
      {
        q: "What packaging formats do you offer?",
        a: "Options include bottles, jars, sachets, pouches, blister packs, and stick packs.",
      },
    ],
  },
  {
    title: "Laboratory & Quality Control",
    overline: "In-house lab",
    items: [
      {
        q: "Do you have an in-house laboratory for quality testing?",
        a: "Yes, White Bull Global operates a well-equipped, in-house laboratory designed to ensure stringent quality control across all stages of production.",
      },
      {
        q: "What kind of testing and services does your laboratory offer?",
        a: "Our laboratory supports a wide range of testing and quality assurance services, including: raw material testing and verification; in-process quality checks during manufacturing; finished product analysis; microbiological testing; stability testing (as required); verification of active ingredient potency; and contamination and safety checks.",
      },
      {
        q: "How does your laboratory ensure product consistency and safety?",
        a: "Our lab follows standard operating procedures aligned with regulatory guidelines to ensure consistency, safety, and efficacy of every batch produced.",
      },
      {
        q: "Can you provide test reports and certifications?",
        a: "Yes, we provide Certificates of Analysis (COA) and other relevant quality documents for each batch as per client and regulatory requirements.",
      },
    ],
  },
  {
    title: "Packaging, Design & End-to-End Solutions",
    overline: "Concept to pack",
    items: [
      {
        q: "Do you assist in selecting the right packaging material and format?",
        a: "Yes, we provide complete guidance in selecting the most suitable packaging material and format based on product type, shelf life, target audience, and market positioning. This includes bottles, jars, sachets, pouches, blister packs, and specialised formats like effervescent tubes.",
      },
      {
        q: "Can you help with packaging design and brand creatives?",
        a: "Absolutely. We support our partners with packaging design inputs, label development, and creative direction to ensure the product stands out while remaining fully compliant with regulatory requirements.",
      },
      {
        q: "Do you offer end-to-end solutions from concept to final product?",
        a: "Yes, White Bull Global offers a comprehensive, end-to-end solution covering product conceptualisation and formulation, packaging selection and sourcing, design and branding support, manufacturing and quality control, documentation and compliance, and final packaging and dispatch.",
      },
      {
        q: "How do you ensure the packaging aligns with the brand positioning?",
        a: "We work closely with our partners to understand their brand vision, target audience, and price positioning, ensuring that the packaging reflects a strong, market-ready identity.",
      },
    ],
  },
  {
    title: "Order & Commercials",
    overline: "Pricing & lead time",
    items: [
      {
        q: "What is the minimum order quantity (MOQ)?",
        a: "MOQ depends on the product type and formulation. We aim to keep it flexible for emerging brands.",
      },
      {
        q: "What is the typical production lead time?",
        a: "Lead time ranges from 3–6 weeks depending on product complexity and order size.",
      },
      {
        q: "How is pricing determined?",
        a: "Pricing depends on formulation, ingredients, packaging, order quantity, and customisation requirements.",
      },
    ],
  },
  {
    title: "Logistics & Supply Chain",
    overline: "Dispatch",
    items: [
      {
        q: "Do you handle logistics and dispatch?",
        a: "Yes, we support pan-India dispatch and can assist with logistics coordination.",
      },
      {
        q: "Can you support bulk and institutional orders?",
        a: "Yes, we cater to both B2B bulk buyers and institutional clients.",
      },
    ],
  },
  {
    title: "Confidentiality & IP",
    overline: "Your formulation is yours",
    items: [
      {
        q: "How do you ensure confidentiality of our formulations?",
        a: "We strictly adhere to Non-Disclosure Agreements (NDAs) and protect all client-specific formulations and data.",
      },
      {
        q: "Will my formulation remain exclusive?",
        a: "Yes, customised formulations developed for you remain confidential and are not shared with other clients.",
      },
    ],
  },
  {
    title: "Business Support & Scalability",
    overline: "Grow with us",
    items: [
      {
        q: "Do you support new and growing brands?",
        a: "Yes, we work with startups as well as established brands, offering scalable solutions.",
      },
      {
        q: "Can you scale production as our business grows?",
        a: "Our facility is designed to support scale-up in line with your business growth.",
      },
      {
        q: "Do you provide marketing or content support?",
        a: "We can assist with product-related content, ingredient insights, and positioning support.",
      },
    ],
  },
  {
    title: "What sets us apart",
    overline: "Differentiation",
    items: [
      {
        q: "What makes White Bull Global different from other manufacturers?",
        a: "Our focus on innovation, quality control, flexible MOQs, and deep understanding of nutraceutical and Ayurvedic products sets us apart.",
      },
    ],
  },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#FAFAFA] border-t border-[#E5E5E5]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="overline">
            <span className="gold-divider mr-3 align-middle" />
            Frequently asked
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A1A1A] mt-6 leading-tight">
            Answers, clearly put.
          </h2>
          <p className="text-[#595959] mt-5 leading-relaxed">
            Everything a brand, distributor or institution typically asks us
            — from formulation and compliance to packaging, confidentiality
            and dispatch.
          </p>
        </div>

        <div className="mt-14 space-y-14">
          {FAQ_GROUPS.map((group, gi) => (
            <div
              key={group.title}
              data-testid={`faq-group-${slug(group.title)}`}
            >
              <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-start">
                <div className="md:col-span-4 md:sticky md:top-28">
                  <div className="overline">
                    <span className="gold-divider mr-3 align-middle" />
                    {group.overline}
                  </div>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1A1A] mt-4 leading-tight">
                    {group.title}
                  </h3>
                </div>

                <div className="md:col-span-8">
                  <Accordion
                    type="single"
                    collapsible
                    className="border-t border-[#E5E5E5]"
                    data-testid={`faq-accordion-${gi}`}
                  >
                    {group.items.map((f, i) => (
                      <AccordionItem
                        key={`${gi}-${i}`}
                        value={`g${gi}-i${i}`}
                        data-testid={`faq-item-${gi}-${i}`}
                        className="border-b border-[#E5E5E5]"
                      >
                        <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl text-[#1A1A1A] py-5 hover:no-underline hover:text-[#C5A059]">
                          {f.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-[#595959] leading-relaxed pb-6 pr-6 text-base">
                          {f.a}
                        </AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
